import { PerformerInfoCombinedProps } from './types';

const usePresenter = (props: PerformerInfoCombinedProps): PerformerInfoCombinedProps => {
  return props;
};

export default usePresenter;
